class ContentSlider extends HTMLElement {
  constructor() {
    super();
    this.timeout = null;

    this.handleResize = () => {
      this._initCarousel();
    };

    this.swiper = null;
    this.swiperLib = null;
    this.lastIsDesktop = null;
  }

  connectedCallback() {
    window.addEventListener("resize", this.handleResize);

    window.loadSwiper.then((swiperLib) => {
      this.swiperLib = swiperLib;

      this._initCarousel();
    });
  }

  disconnectedCallback() {
    window.removeEventListener("resize", this.handleResize);
    this._destroySwiper();
  }

  _destroySwiper() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }

    this.classList.remove("locked");
  }

  _updateAspectRatio() {
    const swiperContent = this.querySelector(".content-tiles__content");
    if (!swiperContent) return;

    const slides = this.querySelectorAll(".swiper-slide");
    const count = slides.length;

    let ratio = 1.15;
    if (count > 3) ratio = 0.55;
    else if (count > 2) ratio = 0.75;

    swiperContent.style.setProperty("--image-aspect-ratio", ratio);
  }

  _initCarousel() {
    if (!this.swiperLib) return;
    const slides = this.querySelectorAll(".swiper-slide");
    const slideCount = slides.length;

    const isDesktop = window.innerWidth >= 600;

    // Only re-init if breakpoint changed or swiper not yet initialized
    if (this.lastIsDesktop === isDesktop && this.swiper !== null) {
      return;
    }
    this.lastIsDesktop = isDesktop;

    // Destroy existing Swiper instance
    this._destroySwiper();

    // Reset widths
    slides.forEach(slide => slide.style.width = '');

    // Custom widths if not enough to trigger carousel
    if (slideCount === 2) {
      slides.forEach(slide => slide.style.width = 'calc((100% - 24px) / 2)');
    } else if (slideCount === 3) {
        slides.forEach(slide => slide.style.width = 'calc((100% - 48px) / 3)');
    } else if (slideCount === 4) {
        slides.forEach(slide => slide.style.width = 'calc((100% - 72px) / 4)');
    }

     // Update the aspect ratio CSS variable
    this._updateAspectRatio();

    // Lock layout if not enough slides on desktop
    if (isDesktop && slideCount < 4) {
      this.classList.add("locked");
      return;
    }

    const { Swiper } = this.swiperLib;

    const swiperParams = {
      slidesPerView: "auto",
      speed: 300,
      spaceBetween: 24,
      navigation: {
        nextEl: this.querySelector("[data-navigation-next]"),
        prevEl: this.querySelector("[data-navigation-previous]"),
      },
      breakpoints: {
        0: {
          slidesPerView: 1.1,
          spaceBetween: 16,
        },
        600: {
          slidesPerView: 2.1,
          spaceBetween: 16,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 24,
        },
        960: {
          slidesPerView: 4.1,
          spaceBetween: 24,
        },
      },
      on: {
        lock: () => {
          this.classList.add("locked");
        },
        unlock: () => {
          this.classList.remove("locked");
        },
      },
    };

    this.swiper = new Swiper(this.querySelector(".swiper"), swiperParams);
  }
}

if (!customElements.get("content-tiles")) {
  customElements.define("content-tiles", ContentSlider);
}